<template>
  <!--begin::Card-->
  <div class="card card-custom clients-basic-info">
    <!--begin::Header-->
    <div class="card-header py-3">
      <div class="card-title flex-column" style="justify-content: space-evenly">
        <h3 class="card-label font-weight-bolder text-dark">
          Ratings & Reviews
        </h3>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <div class="tab-content">
            <v-tabs v-model="activeTab">
              <v-tab>Overall</v-tab>
              <v-tab>Client Inputs</v-tab>
              <v-tab disabled>Ratings to Client</v-tab>
              <v-tab disabled>Settings</v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab">
              <v-tab-item>
                <summary-tab :selectedProject="selectedProject" />
              </v-tab-item>
              <v-tab-item>
                <client-inputs-tab :selectedProject="selectedProject" />
              </v-tab-item>
              <v-tab-item>
                <ratings-to-client-tab :selectedProject="selectedProject" />
              </v-tab-item>
              <v-tab-item>
                <settings-tab :selectedProject="selectedProject" />
              </v-tab-item>
            </v-tabs-items>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SettingsTab from "./ratings/SettingsTab.vue";
import ClientInputsTab from "./ratings/ClientInputsTab.vue";
import RatingsToClientTab from "./ratings/RatingsToClientTab.vue";
import SummaryTab from "./ratings/SummaryTab.vue";

export default {
  name: "RatingsAndReviews",
  components: {
    SettingsTab,
    ClientInputsTab,
    RatingsToClientTab,
    SummaryTab,
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
    selectedProject: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      activeTab: 0,
    };
  },
};
</script>

<style scoped>
.card-custom {
  box-shadow: 0px 0px 30px 0px rgba(82, 63, 105, 0.05);
  background-color: #ffffff;
  background-clip: border-box;
  border: 0 solid #ebedf3;
  border-radius: 0.42rem;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  min-height: 70px;
  padding: 0 2.25rem;
  background-color: transparent;
  border-bottom: 1px solid #ebedf3;
}

.card-body {
  padding: 2rem 2.25rem;
}

.card-title {
  display: flex;
  margin: 0.5rem;
  margin-left: 0;
  flex-wrap: wrap;
  align-items: center;
}

.card-label {
  display: flex;
  align-items: center;
  margin: 0;
  margin-left: 0.75rem;
  margin-right: 0.5rem;
  font-weight: 500;
  color: #181c32;
  font-size: 1.275rem;
}
</style>
